<mds-card [appearance]="'outlined'">
    <!-- mds-card-content has its own padding of 1.6rem -->
    <mds-card-content>
        <!-- p-medpace adds another 1.4 rem of padding -->
        <div class="flex flex-col gap-medpace p-medpace">
            <div class="flex flex-row justify-between">
                <h5>Receipt {{ index() + 1 }}</h5>
                <mds-icon-button
                    [attr.data-cy]="'delete-receipt'"
                    [icon]="'delete'"
                    (clickEvent)="removeReceipt()"
                    [tooltip]="'Delete'"
                    class="danger outline"
                ></mds-icon-button>
            </div>

            <mds-dropdown
                [attr.data-cy]="'receipt-type-dd'"
                [closeOnPageScroll]="false"
                [formCtrl]="formGrp().controls.type"
                [appearance]="'outline'"
                [label]="'Receipt Type'"
                [placeholder]="'Select type'"
                [options]="receiptTypeOptions$ | async"
            />
            <div class="grid grid-cols-4 gap-medpace items-end">
                <medpace-datepicker
                    [formCtrl]="formGrp().controls.receiptDate"
                    [appearance]="'outline'"
                    id="travel-receipt-date"
                    [label]="'Receipt Date'"
                />
                @let currency = currency$ | async;
                <mds-text-field
                    appDisableMouseScroll
                    id="travel-receipt-amount-local-currency"
                    [formCtrl]="formGrp().controls.amountInLocalCurrency"
                    [placeholder]="'Type here...'"
                    [appearance]="'outline'"
                    [inputType]="'decimal'"
                    [label]="!currency ? 'Receipt Amount' : `Receipt Amount (${currency.isocode})`"
                />
                <mds-dropdown
                    [filterable]="true"
                    [closeOnPageScroll]="false"
                    [formCtrl]="formGrp().controls.currency"
                    [appearance]="'outline'"
                    [label]="'Currency'"
                    [placeholder]="'Select currency'"
                    [options]="currencyOptions$ | async"
                />

                @if (!isCrc && amountUsdChip()) {
                    <div>
                        <mds-chip [chips]="amountUsdChip()" [chipListType]="'basic'" [multiple]="true"></mds-chip>
                    </div>
                }
            </div>

            <div>
                <medpace-upload
                    [acceptableTypes]="acceptableFileTypes"
                    [uploadButtonTitle]="'Upload Document'"
                    [inputFile]="formGrp().controls.file.valueChangesReplay | async"
                    [inputFileId]="model()?.attachmentInfoId"
                    [downloadFileFn]="downloadAttachment()"
                    (emitStuff)="onFileSelected($event)"
                    [displayMultipleFilesSizeExceeded]="true"
                ></medpace-upload>
            </div>
            @if (!isCrc) {
                <medpace-merchant-details-edit [formGrp]="formGrp().controls.merchant" />
                <div class="flex flex-row gap-medpace">
                    <mds-text-field
                        class="flex-1"
                        [formCtrl]="formGrp().controls.erTrackingId"
                        [appearance]="'outline'"
                        [label]="'Expense Report Tracking ID'"
                        [placeholder]="'Type here...'"
                        [inputType]="'text'"
                        [id]="'erTrackingId-' + index()"
                    />
                    <mds-text-field
                        class="flex-1"
                        [formCtrl]="formGrp().controls.erReportingPeriod"
                        [appearance]="'outline'"
                        [label]="'ER Reporting Period'"
                        [placeholder]="'Type here...'"
                        [inputType]="'text'"
                        [id]="'erReportingPeriod-' + index()"
                    />
                </div>
            }
            @let isInProcessOrHigher = isInProcessOrHigher$ | async;
            @let elevatedAccess = elevatedAccess$ | async;
            @if (isInProcessOrHigher === true && elevatedAccess === true) {
                <mds-textarea
                    id="receipt-notes-field"
                    [formCtrl]="formGrp().controls.notes"
                    [label]="'Notes'"
                    [appearance]="'outline'"
                    [placeholder]="'Type here...'"
                    [autoSize]="true"
                    [cdkAutosizeMinRows]="4"
                    [cdkAutosizeMaxRows]="8"
                />
            }
        </div>
    </mds-card-content>
</mds-card>
